import * as Rest from "../Generated/RestClient";

export interface ClientAppSettings {
    msaPortalEndpoint: string;
    applicationPath: string;
    environment: string;
    productName: string;
    documentationUrl: string;
    homeUrl: string;
    channels: Rest.Channel[];
    defaultIconUrl: string;
    cdnEndpoint: string;
    searchPrompt?: string;
    searchRoute?: string;
    directLineUrl: string;
    webChatUrl: string;
    flightedFeatures: string[];
    azurePortalEndpoint: string;
    hasCollectedConsent?: boolean;
    cognitiveServicesAuth?: CognitiveServicesAuth;
    luisApiHostName?: string;
    appId?: string;
    enabledFeatures?: Rest.DevPortalFeatureFlags;
}

export interface CognitiveServicesAuth {
    LUIS: string;
    QnA: string;
}

export var clientAppSettings: ClientAppSettings = window['clientAppSettings'];



// WEBPACK FOOTER //
// ./Client/Models/ClientAppSettings.ts